const easternDate = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit',
});

const calendarDay = (date: Date) => {
  const parts = easternDate.formatToParts(date);
  const value = (type: string) => Number(parts.find(part => part.type === type)?.value);
  return Date.UTC(value('year'), value('month') - 1, value('day')) / 86_400_000;
};

export const notificationAge = (createdAt: string, now = new Date()): string => {
  const created = new Date(createdAt);
  if (!Number.isFinite(created.getTime())) return '';
  const days = Math.max(0, calendarDay(now) - calendarDay(created));
  return days === 0 ? 'Today' : `${days}d`;
};
